import WHowInterpreting from './WHowInterpreting'

export default WHowInterpreting
